module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "btn-action",
    attrs: {
      "size": "sm",
      "variant": "outline-secondary",
      "title": "View Logs"
    },
    on: {
      "click": _vm.showModal
    }
  }, [_c('i', {
    staticClass: "fa fa-history"
  })]), _vm._v(" "), _c('b-modal', {
    ref: "log-modal",
    attrs: {
      "size": "xl",
      "hide-footer": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "header-bg-variant": "primary",
      "header-text-variant": "light"
    },
    on: {
      "shown": _vm.initModal,
      "hidden": _vm.resetModal
    }
  }, [_c('template', {
    slot: "modal-title"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fa fa-history mr-2"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.displayTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end mb-3 align-items-center"
  }, [_c('div', [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "outline-success",
      "size": "sm",
      "disabled": _vm.isExporting
    },
    on: {
      "click": _vm.exportLogs
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" " + _vm._s(_vm.isExporting ? 'Exporting...' : 'Export') + "\n         ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-secondary",
      "size": "sm"
    },
    on: {
      "click": _vm.fetchLogs
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Refresh\n         ")])], 1)]), _vm._v(" "), (_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('b-table', {
    staticClass: "mb-0 custom-table",
    attrs: {
      "items": _vm.logs,
      "fields": _vm.fields,
      "show-empty": "",
      "responsive": "",
      "hover": "",
      "head-variant": "light"
    },
    scopedSlots: _vm._u([{
      key: "Sn",
      fn: function(row) {
        return [_vm._v("\n          " + _vm._s((_vm.currentPage - 1) * _vm.perPage + row.index + 1) + "\n        ")]
      }
    }, {
      key: "pl_log_created_at",
      fn: function(row) {
        return [_vm._v("\n          " + _vm._s(_vm.formatDate(row.item.pl_log_created_at)) + "\n        ")]
      }
    }, {
      key: "employeeName",
      fn: function(row) {
        return [_vm._v("\n          " + _vm._s(row.item.pl_log_cu_relation ? row.item.pl_log_cu_relation.employeeName : '-') + "\n        ")]
      }
    }])
  }, [_c('template', {
    slot: "empty"
  }, [_c('div', {
    staticClass: "text-center text-muted my-4"
  }, [_c('p', [_vm._v("No log records found.")])])])], 2)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-3 align-items-center"
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [(_vm.totalRows > 0) ? _c('div', {
    staticClass: "text-muted small"
  }, [_vm._v("\n                 Showing " + _vm._s((_vm.currentPage - 1) * _vm.perPage + 1) + " to " + _vm._s(Math.min(_vm.currentPage * _vm.perPage, _vm.totalRows)) + " of " + _vm._s(_vm.totalRows) + " entries\n             ")]) : _vm._e()]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-pagination', {
    staticClass: "mb-0 custom-pagination",
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "right",
      "pills": "",
      "size": "sm"
    },
    on: {
      "change": _vm.onPageChange
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-3 border-top pt-3"
  }, [_c('b-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-danger",
      "size": "sm"
    },
    on: {
      "click": _vm.hideModal
    }
  }, [_vm._v("Close")])], 1)], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-963b6b24","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/profitLoss/ProfitLossLogModal.vue
// module id = 2802
// module chunks = 0